import { render } from "./BlockCenter.vue?vue&type=template&id=1fa90392"
import script from "./BlockCenter.vue?vue&type=script&lang=js"
export * from "./BlockCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__